import React from 'react';

import Styled from 'styled';
import SVGIcon from 'lib/images/svg-icon/svg-icon';

import like from 'four-nets/icons/svg/icon_like-2.svg';
import like2 from 'four-nets/icons/svg/icon_like-2.svg';

import Button from 'four-nets/photoblog/posts/common/footer/buttons/button/button';

import LikersDialog from './image-likers-dialog';
import defaultStyles from './image-likers-button.scss';

export interface Props {
    styles: typeof defaultStyles;
    likesCount: number | null;
    id: string;
}

interface State {
    open: boolean;
}

class ImageLikersButton extends React.PureComponent<Props, State> {
    state = {
        open: false,
    };

    close = () => {
        this.setState({ open: false });
    };

    open = () => {
        this.setState({ open: true });
    };

    render() {
        const { styles, likesCount, id } = this.props;

        return (
            <React.Fragment>
                <LikersDialog id={id} open={this.state.open} onClose={this.close} />
                <Button
                    style={{ button: styles.feedButton }}
                    onClick={this.open}
                    onTouchEnd={this.open}
                    disabled={!likesCount || likesCount === 0}
                >
                    <span className={styles!.likeCount}>
                        <SVGIcon style={{ image: styles.icon }} src={!likesCount || likesCount === 0 ? like : like2} />
                        {likesCount}
                    </span>
                </Button>
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(ImageLikersButton);
